module.exports = __webpack_public_path__ + "assets/tagline_web_desktop_en.svg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/taglines/tagline_web_desktop_en.svg
// module id = 443
// module chunks = 19